export default {
  // deprecated
  googleRedirectUri: "https://testes-quarkclinic-mol.esig.com.br",
  baseUrl: "https://testes-quarkclinic-mol-back.esig.com.br/api/",
  vueAuth: "/api/social",
  google: {
    // XXX: a ser depreciado
    clientId: "681146735072-osvebcsnu3k48gee5asq0ojf3dn4qsd3.apps.googleusercontent.com",
    // novo clientId
    // clientId: "72459285399-oeeq046eeh32iee4a49ah64ksb1vgdjc.apps.googleusercontent.com",
    redirectUri: "https://testes-quarkclinic-mol.esig.com.br",
  },
  facebook: {
    clientId: "433933307655063",
    redirectUri: "https://testes-quarkclinic-mol.esig.com.br/oauth",
  },
};
